import React, { useRef, useState } from "react";

import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { NotificationToast } from "../../../components/Generic/Toast/NotificationToast";
import { useAppState } from "../../../context/StateContext";
import CustomerPortalService from "../../../services/customer.portal.service";
import { ForgotPasswordCredentials } from "../../../types";
import ForgotPasswordForm, { ForgotPasswordFormHandle } from "./Form";

const CustomerPortalForgotPassword = () => {
  const [emailSent, setEmailSent] = useState<boolean>(false);

  const forgotPasswordRef = useRef<ForgotPasswordFormHandle>(null);
  const { subDomainInfo } = useAppState();
  const { t: translate } = useTranslation();

  const { mutate: forgotPassword, isLoading } = useMutation(
    ["forgot.password.customer.portal"],
    (forgotPasswordData: ForgotPasswordCredentials) =>
      CustomerPortalService.forgotPassword(forgotPasswordData),
    {
      onError: () => {
        NotificationToast.error(translate("couldNotSendEmail"));
      },
    }
  );

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (subDomainInfo?.companyId) {
      forgotPassword(
        { email: forgotPasswordRef?.current?.email ?? "", companyId: subDomainInfo?.companyId },
        {
          onSuccess: (response) => {
            if (response.data) {
              NotificationToast.success(
                `${translate("ifAMatchingAccountWasFoundAnEmailWasSentTo")} ${
                  forgotPasswordRef?.current?.email
                } ${translate("toAllowYouToResetYourPassword")}`
              );
              setEmailSent(true);
            }
          },
        }
      );
    }
  };

  return (
    <ForgotPasswordForm
      ref={forgotPasswordRef}
      emailSent={emailSent}
      isLoading={isLoading}
      handleSubmit={handleSubmit}
    />
  );
};

export default CustomerPortalForgotPassword;
